import { gsap } from "gsap";

export default class SelectTabHandler {
    private section: HTMLElement;
    private categoryButtons: HTMLButtonElement[] | null;
    private selects: HTMLSelectElement[] | null;
    private tabs: HTMLElement[] | null;
    private activeSelect: HTMLSelectElement | null = null;
    private activeTab: HTMLElement | null = null;

    constructor(section: HTMLElement) {
        this.section = section;
        this.categoryButtons = [...this.section.querySelectorAll<HTMLButtonElement>(".tab-button")];
        this.selects = [...this.section.querySelectorAll<HTMLSelectElement>("select")];
        this.tabs = [...this.section.querySelectorAll<HTMLElement>(".tabs-wrapper")];

        this.init();
    }

    public init = async (): Promise<void> => {
        if (!this.categoryButtons || !this.categoryButtons || !this.section) return;

        this.findActiveSelect();
        this.selectListener();

        this.categoryButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                this.switchCategory(e);
                this.switchSelectBar(e);
                this.findActiveSelect();
                this.handleTab(e);
                this.selectListener();
            });
        });
    };

    private selectListener = () => {
        if (!this.activeSelect) return;

        this.activeSelect.addEventListener("change", this.handleTab);
    };

    private switchCategory = ({ currentTarget }: MouseEvent) => {
        if (!currentTarget) return;

        const currentCategory = currentTarget as HTMLButtonElement;

        this.categoryButtons?.forEach((category) => {
            category.classList.remove("tab-button--active");
        });

        currentCategory.classList.add("tab-button--active");
    };

    private switchSelectBar = ({ currentTarget }: MouseEvent) => {
        if (!this.selects || !currentTarget) return;

        const currentCategory = currentTarget as HTMLButtonElement;

        this.selects.forEach((select) => {
            select.classList.remove("tab-select--active");

            if (select.dataset.select === currentCategory.dataset.category) {
                select.classList.add("tab-select--active");

                const slimSelectEl = select.nextSibling as HTMLElement;
                if (!slimSelectEl) return;

                slimSelectEl.click();
            }
        });
    };

    private findActiveSelect = () => {
        if (!this.selects) return null;

        const activeSelect = this.selects.filter((select) => select.classList.contains("tab-select--active"));

        this.activeSelect = activeSelect[0];
    };

    private handleTab = async ({ currentTarget }: Event): Promise<void> => {
        if (!currentTarget) return;

        const target = currentTarget as HTMLElement;
        const currentSelect = target.classList.contains("tab-button") ? this.activeSelect : (currentTarget as HTMLSelectElement);

        if (!currentSelect) return;

        await this.easeIn(this.tabs);

        this.tabs?.forEach((tab) => {
            tab.classList.remove("tabs-wrapper--visible");

            if (tab.dataset.tab === currentSelect.value) {
                this.activeTab = tab;
                tab.classList.add("tabs-wrapper--visible");
            }
        });

        await this.easeOut(this.activeTab);
    };

    private easeOut = async (item): Promise<void> => {
        gsap.to(item, { opacity: 0, duration: 0.2 });
    };

    private easeIn = async (item): Promise<void> => {
        gsap.fromTo(item, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.2, delay: 0.2 });
    };
}
